import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import { SAFETY_FAQ_BY_LOCALE } from '@/data/shared/safetyFaq';

import { SolutionFaqSection } from '../../shared/SolutionFaqSection';

/**
 * ### SafetyFaqSection
 *
 * Places the shared FAQ section on the Listen AI Safety page with the Safety
 * copy, which is the same list the page emits as FAQPage structured data, so
 * the rendered questions and the schema can never drift.
 *
 * @returns The rendered FAQ section element
 * @see {@link SAFETY_FAQ_BY_LOCALE} The copy rendered here
 * @see {@link SolutionFaqSection} The shared section this configures
 */
export default function SafetyFaqSection() {
  const { t } = useTranslation('common');
  const currentLang = useCurrentLang();

  return (
    <SolutionFaqSection
      tone="dark"
      analyticsSectionId="safety_faq"
      title={t('자주 묻는 질문')}
      items={SAFETY_FAQ_BY_LOCALE[currentLang]}
    />
  );
}
